import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "modal" }
const _hoisted_2 = { class: "trade-container" }
const _hoisted_3 = {
  key: 0,
  class: "image-preview"
}
const _hoisted_4 = ["src", "onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "trade-notes" }
const _hoisted_7 = { class: "status-selector" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "close-btn",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
    }, "✖"),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "trade-pics",
        onPaste: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handlePaste && _ctx.handlePaste(...args)))
      }, [
        _cache[9] || (_cache[9] = _createElementVNode("h2", null, "TRADE PICS", -1)),
        _cache[10] || (_cache[10] = _createElementVNode("label", {
          for: "file-upload",
          class: "upload-label"
        }, " 📂 Add image ", -1)),
        _createElementVNode("input", {
          type: "file",
          id: "file-upload",
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args))),
          hidden: ""
        }, null, 32),
        (_ctx.trade.imageUrls.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trade.imageUrls, (image, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "image-item"
                }, [
                  _createElementVNode("img", {
                    src: image,
                    class: "trade-img",
                    onClick: ($event: any) => (_ctx.openImage(image)),
                    onMouseover: _cache[2] || (_cache[2] = ($event: any) => (_ctx.zoomImage($event))),
                    onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.resetZoom($event)))
                  }, null, 40, _hoisted_4),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.removeImage(index))
                  }, "🗑", 8, _hoisted_5)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ], 32),
      _createElementVNode("div", _hoisted_6, [
        _cache[13] || (_cache[13] = _createElementVNode("h2", null, "NOTES", -1)),
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.trade.note) = $event)),
          placeholder: "Add your comment here..."
        }, null, 512), [
          [_vModelText, _ctx.trade.note]
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[12] || (_cache[12] = _createElementVNode("label", null, "Statut :", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.trade.status) = $event))
          }, _cache[11] || (_cache[11] = [
            _createElementVNode("option", { value: "Win" }, "Win", -1),
            _createElementVNode("option", { value: "Loss" }, "Loss", -1)
          ]), 512), [
            [_vModelSelect, _ctx.trade.status]
          ])
        ]),
        _createElementVNode("button", {
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.saveTrade && _ctx.saveTrade(...args))),
          disabled: _ctx.isUploading
        }, _toDisplayString(_ctx.isUploading ? "Saving..." : "Saved"), 9, _hoisted_8)
      ])
    ]),
    (_ctx.zoomedImage)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "lightbox",
          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closeImage && _ctx.closeImage(...args)))
        }, [
          _createElementVNode("img", {
            src: _ctx.zoomedImage,
            class: "fullsize-img"
          }, null, 8, _hoisted_9)
        ]))
      : _createCommentVNode("", true)
  ]))
}